import { render, staticRenderFns } from "./tresentry.vue?vue&type=template&id=d65b3a56"
import script from "./tresentry.vue?vue&type=script&lang=js"
export * from "./tresentry.vue?vue&type=script&lang=js"
import style0 from "./tresentry.vue?vue&type=style&index=0&id=d65b3a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports